import { render, staticRenderFns } from "./Medals.vue?vue&type=template&id=9c06b8d8&"
import script from "./Medals.vue?vue&type=script&lang=js&"
export * from "./Medals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports